import "../../Pages/HomePage.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import soundFile from "../Modals/alert1.wav";
import { Howl } from "howler";
import { resumeAudio } from "../../Constant/audio";

const LoginInfoModal = ({ isModalOpen, setIsModalOpen }) => {
  // Closing this modal is the first real user gesture after login, which is the
  // browser's cue to unlock audio. Playing a quiet beep here primes the context
  // so the first alert of the shift is audible.
  const handleClose = () => {
    try {
      resumeAudio();
      const sound = new Howl({
        src: [soundFile],
        volume: 0.1,
        autoplay: false,
        onloaderror: (id, err) => {
          console.error("[Howl load error]", id, err);
        },
        onplayerror: (id, err) => {
          console.error("[Howl play error]", id, err);
          resumeAudio();
          // Howler fires onunlock once the context is usable again
          sound.once("unlock", () => sound.play());
        },
        onend: () => sound.unload()
      });
      sound.play();
    } catch (e) {
      console.error("Unexpected audio unlock error:", e);
    }

    setIsModalOpen(false);
  };

  return (
    <Modal show={isModalOpen} onHide={handleClose}>
      <Modal.Header closeButton style={{ backgroundColor: "#212529" }}>
        <h5 style={{ color: "#fff" }}>Welcome to SenSen.AI</h5>
      </Modal.Header>
      <div style={{ backgroundColor: "#212529", color: "#adb5bd" }} className="modal-body">
        <p>Your app is now logged in. If you have any issues, please contact</p>
        <p>scancam.support@sensen.ai</p>
      </div>
      <Modal.Footer style={{ backgroundColor: "#212529" }}>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginInfoModal;
